<script>
  import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
  } from 'sveltestrap';

  export let open, mode;
</script>

<Modal isOpen={open} toggle={() => (open = !open)}>
  <ModalHeader toggle={() => (open = !open)}
    >{`${
      mode == 'order' ? 'Order' : 'Approval'
    } Confirmation Notification`}</ModalHeader
  >
  <ModalBody>{`your ${mode} has been submitted!`}</ModalBody>
  <ModalFooter>
    <Button color="danger" on:click={() => (open = !open)}>Close</Button>
  </ModalFooter>
</Modal>
